import { useContext, useEffect, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import { useMsal } from '@azure/msal-react'
import { authContext } from '../contexts/AuthContext'
import { apiUrl } from '../config/api'

const AuthCallback = () => {
  const { instance, inProgress } = useMsal()
  const { setAuthData } = useContext(authContext)
  const history = useHistory()
  const handled = useRef(false)

  useEffect(() => {
    // MsalProvider already calls handleRedirectPromise() itself on init and
    // drives inProgress through 'startup' -> 'handleRedirect' -> 'none'.
    // Wait for that to fully finish before touching accounts/tokens — calling
    // handleRedirectPromise() again ourselves consumes nothing (MsalProvider
    // already did) and leaves MSAL's interaction lock stuck, hanging any
    // later acquireTokenSilent call.
    if (inProgress !== 'none') return
    if (handled.current) return
    handled.current = true

    const processBackendLogin = async () => {
      try {
        const accounts = instance.getAllAccounts()

        if (accounts.length === 0) {
          console.warn(
            'AuthCallback: No accounts found after redirect processing.'
          )
          history.replace('/SignInAD')
          return
        }

        const activeAccount = accounts[0]
        instance.setActiveAccount(activeAccount)

        console.log(
          'AuthCallback processing backend swap for:',
          activeAccount.username
        )

        const tokenResponse = await instance.acquireTokenSilent({
          account: activeAccount,
          scopes: ['User.Read', 'email'] // Match your loginRequest scopes exactly
        })

        const targetUrl = `${apiUrl('ADLogin')}&msalToken=${encodeURIComponent(tokenResponse.accessToken)}&brandLabel=${encodeURIComponent(window.$brand)}`;
        const res = await fetch(targetUrl, {
          method: 'POST'
        })

        console.log('ADLogin status:', res.status)

        if (res.status === 200) {
          const raw = await res.text()
          const tokenString = raw.replace(/^"|"$/g, '')
          const base64 = tokenString
            .split('.')[1]
            .replace(/-/g, '+')
            .replace(/_/g, '/')
          const payload = JSON.parse(atob(base64))

          const user = {
            id: payload.id,
            first_name: payload.first_name,
            last_name: payload.last_name,
            userType: payload.user_type,
            email: payload.email,
            image_url: payload.image_url,
            phone: payload.phone,
            mobile: payload.mobile,
            role: payload.role
          }

          setAuthData('blp', user, tokenString, tokenString)
          history.replace('/Clientes')
          return
        }

        if (res.status === 401) {
          console.warn('ADLogin 401 — user not authorized')
          instance.setActiveAccount(null)
          history.replace('/SignInAD', { authError: true })
          return
        }

        console.error('Unhandled ADLogin status:', res.status)
        history.replace('/SignInAD', { authError: true })
      } catch (err) {
        console.error('Error during token processing or API exchange:', err)
        history.replace('/SignInAD', { authError: true })
      }
    }

    processBackendLogin()
  }, [inProgress, instance, history, setAuthData])

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}
    >
      <p>Iniciando sesión…</p>
    </div>
  )
}

export default AuthCallback
